import { NgModule, Injector } from '@angular/core';
import { ImportMaterialModule } from '../material.module';
import { SmartGrid } from './grid';
import { SmartRow } from './row';
import { SmartCol } from './col';
import { SmartHeader } from './header';
import { BrowserModule } from '@angular/platform-browser';
import { SmartToolbar } from './toolbar';
import { SmartTabSet } from '../tabs/tabset';
import { SmartTabItem } from '../tabs/tab';
import { SplitPanes } from '../pane/split.panes';
import { CommonModule } from '@angular/common';
import { SplitPanesOld } from '../pane/split.panes.old';
import { SmartTile } from './tile';


@NgModule({
  imports: [
    ImportMaterialModule,
    CommonModule,
  ],
  declarations: [
      SmartGrid, SmartRow, SmartCol, SmartTile,
      SmartHeader,
      SmartToolbar,
      SmartTabSet, SmartTabItem,
      SplitPanesOld,
      SplitPanes,
  ],
  exports: [
    SmartGrid, SmartRow, SmartCol, SmartTile,
    SmartHeader,
    SmartToolbar,
    SmartTabSet, SmartTabItem,
    SplitPanes,
],
  entryComponents: [
  ],
  providers: [ 
    ]
})
export class LayoutModule {

    // constructor(private injector: Injector) {
    //     const explorer = createCustomElement(MeetingCard, {injector: this.injector});
    
    //     customElements.define('ess-meeting-card', explorer as any);
    //     console.log("Registered element " + "ess-meeting-card");

    // }
}
